import React, { useState, useEffect } from "react";
import { Box, Typography, useMediaQuery, styled } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { getAuth, signOut, updateProfile } from "firebase/auth";
import Toast from "react-hot-toast";
import Routes from "../../../utils/Routes";
import Navigation from "../../../navigations/Navigation";
import TextBox from "../../../components/TextField";
import Button from "../../../components/Button";
import Alert from "../../../components/Alert";
import { getDisplayName } from "../../../utils/Utils";

const ProfileScreen = ({ className }) => {
  const navigate = useNavigate();
  const auth = getAuth();
  const user = auth.currentUser;

  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [modalVisible, setModalVisible] = useState(false);
  const [confirmEmail, setConfirmEmail] = useState("");
  const [password, setPassword] = useState("");
  const [isEditing, setIsEditing] = useState(false);
  const [alert, setAlert] = useState({
    open: false,
    message: "",
    severity: "error",
  });

  useEffect(() => {
    setName(getDisplayName(user?.displayName));
    setEmail(user?.email);
    setPhoneNumber(user?.phoneNumber);
  }, []);

  // Logout Handler
  const logoutHandler = async () => {
    await signOut(auth);
    localStorage.clear();
    navigate("/" + Routes.LogIn);
  };

  // Delete Account Confirmation
  // const confirmDeleteAccount = () => {
  //   window.alert("Are you sure you want to delete your account?");
  //   setModalVisible(true);
  // };

  // Delete Account with Re-authentication
  // const deleteAccount = async () => {
  //   if (!confirmEmail || confirmEmail !== email) {
  //     window.alert("Invalid email. Please enter the correct email.");
  //     return;
  //   }
  //   if (!password) {
  //     window.alert("Please enter your password.");
  //     return;
  //   }

  //   try {
  //     setIsLoading(true);
  //     const credential = EmailAuthProvider.credential(confirmEmail, password);
  //     await reauthenticateWithCredential(user, credential);
  //     await deleteUser(user);

  //     localStorage.clear();
  //     navigate("/login");
  //     Toast.success("Account deleted successfully!");
  //   } catch (error) {
  //     setAlert({ open: true, message: error.message, severity: "error" });
  //   } finally {
  //     setIsLoading(false);
  //     setModalVisible(false);
  //   }
  // };

  const handleEditClick = () => {
    setIsEditing(true);
  };

  const handleUpdateClick = async () => {
    const referralCode = localStorage.getItem("ReferralCode");
    const user = auth.currentUser;
    if (!user) return;

    try {
      setIsLoading(true);
      await updateProfile(user, { displayName: `${name}#${referralCode}` });
      setAlert({
        open: true,
        message: "Profile updated successfully!",
        severity: "success",
      });
      setIsEditing(false);
    } catch (error) {
      setAlert({ open: true, message: error.message, severity: "error" });
    } finally {
      setIsLoading(false);
    }
  };

  const handleChange = (e) => {
    setName(e.target.value);
    if (!isEditing) setIsEditing(true);
  };

  const handleCancel = () => {
    setIsEditing(false);
    setName(getDisplayName(user?.displayName || ""));
  };

  return (
    <>
      <Navigation />
      <div className={className}>
        <Box className="scrollableContent">
          <Box className="container">
            <Typography className="text">Profile</Typography>

            <Box className="form">
              <TextBox
                placeholder="Full Name"
                value={name}
                onChange={handleChange}
                disabled={!isEditing}
              />
              <TextBox placeholder="Email" value={email} disabled />
              <TextBox
                placeholder="Phone Number"
                value={phoneNumber}
                disabled
              />

              <Box className="buttonContainer">
                <Button
                  label={isEditing ? "Update Profile" : "Edit Profile"}
                  variant="contained"
                  onClick={isEditing ? handleUpdateClick : handleEditClick}
                  disabled={isEditing && !name.trim()}
                  loading={isLoading}
                />
                <Button
                  label={isEditing ? "Cancel" : "Logout"}
                  variant="outlined"
                  onClick={isEditing ? handleCancel : logoutHandler}
                />
              </Box>
            </Box>

            {/* Delete Account Dialog */}
            {/* <Dialog open={modalVisible} onClose={() => setModalVisible(false)}>
              <DialogTitle>Confirm Account Deletion</DialogTitle>
              <DialogContent>
                <TextField
                  label="Enter Email"
                  fullWidth
                  value={confirmEmail}
                  onChange={(e) => setConfirmEmail(e.target.value)}
                />
                <TextField
                  label="Enter Password"
                  fullWidth
                  type="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                />
              </DialogContent>
              <DialogActions>
                <Button onClick={() => setModalVisible(false)}>Cancel</Button>
                <Button
                  onClick={deleteAccount}
                  color="error"
                  variant="contained"
                >
                  {isLoading ? (
                    <CircularProgress size={24} sx={{ color: "white" }} />
                  ) : (
                    "Delete"
                  )}
                </Button>
              </DialogActions>
            </Dialog> */}
          </Box>
        </Box>
      </div>
      <Alert
        open={alert.open}
        message={alert.message}
        severity={alert.severity}
        onClose={() => setAlert({ ...alert, open: false })}
      />
    </>
  );
};

export default styled(ProfileScreen)(({ theme }) => ({
  ".container": {
    maxWidth: "500px",
    margin: "auto",
    padding: "20px",
    textAlign: "center",
    [theme.breakpoints.down("sm")]: {
      maxWidth: "90%",
      padding: "15px",
    },
  },
  ".scrollableContent": {
    position: "fixed",
    top: "64px", // Adjust based on the height of the navigation bar
    bottom: "56px", // Adjust based on the height of the bottom navigation
    left: 0,
    right: 0,
    overflowY: "auto",
    padding: "20px",
  },
  ".text": {
    fontWeight: 700,
    fontSize: 50,
    color: "#234000",
    "@media (max-width: 768px)": {
      display: "none",
    },
  },
  ".form": {
    display: "flex",
    flexDirection: "column",
    gap: "15px",
  },
  ".buttonContainer": {
    display: "flex",
    flexDirection: "column",
    gap: "10px",
  },
}));
